import {
    CLASSES_CREATE_CLASSES,
    CLASSES_CREATE_CLASSES_FAILURE,
    CLASSES_CREATE_CLASSES_SUCCESS,
    CLASSES_EDIT_CLASSES,
    CLASSES_EDIT_CLASSES_FAILURE,
    CLASSES_EDIT_CLASSES_SUCCESS,
    CLASSES_GET_CLASSES,
    CLASSES_GET_CLASSES_FAILURE,
    CLASSES_GET_CLASSES_SUCCESS,
    CLASSES_REMOVE_CLASSES,
    CLASSES_REMOVE_CLASSES_FAILURE,
    CLASSES_REMOVE_CLASSES_SUCCESS,
    CLASSES_PROPS_CHANGED,
} from "./actions";

export const dispatchOnClassesGetClasses = () => dispatch => {
    dispatch({type: CLASSES_GET_CLASSES})
};

export const dispatchOnClassesGetClassesSuccess = (response) => dispatch => {
    dispatch({
        type: CLASSES_GET_CLASSES_SUCCESS,
        classes: response.data,
        pagination: response.pagination,
    })
};

export const dispatchOnClassesGetClassesFailure = (error) => dispatch => {
    dispatch({type: CLASSES_GET_CLASSES_FAILURE})
};

export const dispatchOnClassesCreateClasses = () => dispatch => {
    dispatch({type: CLASSES_CREATE_CLASSES})
};

export const dispatchOnClassesCreateClassesSuccess = (response) => dispatch => {
    dispatch({
        type: CLASSES_CREATE_CLASSES_SUCCESS,
        class: response.data,
    })
};

export const dispatchOnClassesCreateClassesFailure = (error) => dispatch => {
    dispatch({type: CLASSES_CREATE_CLASSES_FAILURE})
};

export const dispatchOnClassesEditClasses = () => dispatch => {
    dispatch({type: CLASSES_EDIT_CLASSES})
};

export const dispatchOnClassesEditClassesSuccess = (response) => dispatch => {
    dispatch({
        type: CLASSES_EDIT_CLASSES_SUCCESS,
        class: response.data,
    })
};

export const dispatchOnClassesEditClassesFailure = (error) => dispatch => {
    dispatch({type: CLASSES_EDIT_CLASSES_FAILURE})
};

export const dispatchOnClassesRemoveClasses = () => dispatch => {
    dispatch({type: CLASSES_REMOVE_CLASSES})
};

export const dispatchOnClassesRemoveClassesSuccess = (response) => dispatch => {
    dispatch({
        type: CLASSES_REMOVE_CLASSES_SUCCESS,
        class: response.data,
    })
};

export const dispatchOnClassesRemoveClassesFailure = (error) => dispatch => {
    dispatch({type: CLASSES_REMOVE_CLASSES_FAILURE})
};

export const dispatchOnClassesEditModeChanged = (showEditModal, classInfo, index) => dispatch => {
    dispatch({
        type: CLASSES_PROPS_CHANGED,
        classInfo,
        index,
        showEditModal,
    })
};

export const dispatchOnClassesRemoveModeChanged = (showRemoveModal, classInfo, index) => dispatch => {
    dispatch({
        type: CLASSES_PROPS_CHANGED,
        classInfo,
        index,
        showRemoveModal,
    })
};

export const dispatchOnClassesPropsChanged = (props) => dispatch => {
    dispatch({
        type: CLASSES_PROPS_CHANGED,
        ...props,
    });
};